(function ($) {
  mppProductV1 = {
    formatter: $('.mpp-product-v1')
  };

  Drupal.behaviors.mppProductV1 = {
    get: function (key) {
      return mppProductV1[key];
    },

    set: function (key, val) {
      mppProductV1[key] = val;
    },

    attach: function (context, settings) {
      var self = this;
      var formatter = self.get('formatter');

      formatter.each(function () {
        var thisFormatter = $(this);

        // quickview slide down
        thisFormatter.find('.btn-quickview').once('template-btn-quickview').on('click', function(e) {
          e.preventDefault();

          var prodId = $(this).closest('.product').attr('data-productid');

          if (typeof prodId !== 'undefined') {
            var product = page_data['product-input-type'].products.filter(function (p) {
              return p.PRODUCT_ID === prodId;
            })[0];
            var $qs = site.quickshop.render({
              productData: product
            });

            // close any other open qs
            $('#quickshop').slideUp('0', function () {
              $(this).remove();
              $('div[data-productid="' + product.PRODUCT_ID + '"] .caret').addClass('hidden');
            });

            var clickedProduct = $(this).closest('.product');
            var bottom_padding = 50;
            var speed = 500;
            var topPositionNavOffset = $('#top').height() + 40;

            // append after row
            $qs.insertAfter($(this).parents('.row')).delay(100).slideDown(speed, function () {
              var pos = $qs.position();
              var window_height = $(window).height();
              var offset = $qs.offset();
              var posY = offset.top - $(window).scrollTop();
              var clickedProductOffset = clickedProduct.offset();
              var clickedProductY = clickedProductOffset.top - $(window).scrollTop();
              var qs_bottom_position = posY + $('#quickshop').height() + bottom_padding;

              // only scroll page if the quickshop fall within the viewable area
              if (qs_bottom_position > window_height) {
              /**
               * bottom of quickshop isn't visible, so let's formulate both options
              **/
                // option 1: place selected product near top of viewing area
                var prod_row = (clickedProductY - topPositionNavOffset) + $(window).scrollTop();
                // option 2: place quickshop within viewing area, sacrifice selected product in viewport if needed
                var quickshop_in_viewport = (qs_bottom_position - window_height) + $(window).scrollTop();
                // select our best option
                var scrollPosition = quickshop_in_viewport < prod_row ? prod_row : quickshop_in_viewport;

                // now scroll the window...
                $('body, html').scrollTo(scrollPosition, {
                  duration: speed,
                  axis: 'y'
                });
              }
            });
            // override close to remove dom node
            $qs.find('.close').off('click').on('click', function() {
              $qs.slideUp('500', function () {
                $qs.remove();
                $('div[data-productid="' + product.PRODUCT_ID + '"] .caret').addClass('hidden');
              });
            });
            // show caret
            $('div[data-productid="' + product.PRODUCT_ID + '"] .caret').removeClass('hidden');
          }
        });
      });
    }
  };
})(jQuery);
